<div class="wetter-terminal-label">
<span [style]="label?.inlineStyle" class="text">
  {{label?.caption}}
</span>
</div>
